import {createEvent} from "react-event-hook";

/**
 * name is the name of the command that was executed
 *
 * content is the response to the command.  This could be a plain string, or could be serialized data structure expected
 * to be parsed by the client.  Will vary depending on the command.
 */
export interface GuideCommandPayload {
    name: string;
    content: string;
}

/**
 * This event is emitted within the ai-guide frontend code whenever the backend
 * streams back a "command token" (as opposed to a normal chat token, which is
 * added to the chat conversation).
 *
 * Components can send commands, and then listen for the response.
 */
export const {useGuideCommandListener, emitGuideCommand} =
    createEvent("guide-command")<GuideCommandPayload>();
